import { createSelector } from '@reduxjs/toolkit';
import { FOfferType } from '../../../packages/JsonQuery';
import { selectOfferType } from './selectOfferType';

export const selectIsNewbuildingListing = createSelector(
  selectOfferType,
  offerType => offerType === FOfferType.FlatNew,
);
